import { VCol, VPagination, VRow, VSelect, VNavigationDrawer, VListItem, VListItemAvatar, VIcon, VListItemContent, VListItemTitle, VDivider, VList, VListItemGroup, VAppBar, VAppBarNavIcon, VToolbarTitle, VListItemIcon, VListItemAction, VListGroup, VContainer, VTextField, VProgressCircular, VDialog, VCard, VCardText } from 'vuetify/lib';

//
var script$5 = {
  props: {
    classItemsPerPage: {
      type: String,
      default: ''
    },
    showItemsPerPage: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => {
        return [];
      }
    },
    valueItemsPerPage: {
      type: Number,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    totalVisible: {
      type: Number || String,
      default: undefined
    },
    length: {
      type: Number,
      default: null
    },
    valuePage: {
      type: Number,
      default: 1
    },
    totalLengthList: {
      type: Number,
      default: 0
    }
  },
  components: {
    VCol,
    VPagination,
    VRow,
    VSelect
  },
  data: () => ({
    modelItemsPerPage: null,
    modelPage: null
  }),
  computed: {
    getLength() {
      if (this.length !== null || this.totalLengthList === 0) return this.length;
      let pages = this.totalLengthList / this.valueItemsPerPage;

      if (pages > parseInt(pages)) {
        return parseInt(pages) + 1;
      }

      return pages;
    },

    getMdPagination() {
      return this.showItemsPerPage ? '10' : '12';
    }

  },
  methods: {
    validPage() {
      //Se a pagina selecionada não existe mais como opção, deve selecionar a pagina 1
      if (parseInt(this.getLength) < parseInt(this.modelPage)) {
        this.modelPage = 1;
        this.onPageChange();
      }
    },

    onItemsPerPageChange() {
      this.$emit('update:valueItemsPerPage', this.modelItemsPerPage);
      this.$emit('onItemsPerPageChange', this.modelItemsPerPage);
      this.onChange();
    },

    onPageChange() {
      this.$emit('update:valuePage', this.modelPage);
      this.$emit('onPageChange', this.modelPage);
      this.onChange();
    },

    onChange() {
      this.$emit('change', {
        page: this.modelPage,
        itemsPerPage: this.modelItemsPerPage
      });
    }

  },

  mounted() {
    this.modelPage = this.valuePage;
    this.modelItemsPerPage = this.valueItemsPerPage;
    this.validPage();
  },

  watch: {
    valuePage() {
      this.modelPage = this.valuePage;
    },

    valueItemsPerPage() {
      this.modelItemsPerPage = this.valueItemsPerPage;
      this.validPage();
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-row', [_vm.showItemsPerPage ? _c('v-col', {
    class: _vm.classItemsPerPage,
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.label,
      "items": _vm.items,
      "disabled": _vm.loading || _vm.disabled
    },
    on: {
      "change": _vm.onItemsPerPageChange
    },
    model: {
      value: _vm.modelItemsPerPage,
      callback: function ($$v) {
        _vm.modelItemsPerPage = $$v;
      },
      expression: "modelItemsPerPage"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": _vm.getMdPagination
    }
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.getLength,
      "total-visible": _vm.totalVisible,
      "disabled": _vm.loading || _vm.disabled
    },
    on: {
      "input": function ($event) {
        return _vm.onPageChange();
      }
    },
    model: {
      value: _vm.modelPage,
      callback: function ($$v) {
        _vm.modelPage = $$v;
      },
      expression: "modelPage"
    }
  })], 1)], 1);
};

var __vue_staticRenderFns__$5 = [];
/* style */

const __vue_inject_styles__$5 = undefined;
/* scoped */

const __vue_scope_id__$5 = undefined;
/* module identifier */

const __vue_module_identifier__$5 = undefined;
/* functional template */

const __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, undefined, undefined, undefined);

//
var script$4 = {
  components: {
    VNavigationDrawer,
    VListItem,
    VListItemAvatar,
    VIcon,
    VListItemContent,
    VListItemTitle,
    VDivider,
    VList,
    VListItemGroup,
    VAppBar,
    VAppBarNavIcon,
    VToolbarTitle,
    VListItemIcon,
    VListItemAction,
    VListGroup,
    VContainer,
    VTextField
  },
  model: {
    prop: "menuSelect"
  },
  props: {
    menuSelect: {
      type: String | Number,
      default: ""
    },
    drawer: {
      type: Boolean,
      default: false
    },
    menuItems: {
      type: Array,
      default: () => {
        return [];
      }
    },
    titleAppBar: {
      type: String,
      default: ""
    },
    classDrawer: {
      type: String,
      default: ""
    },
    classMenu: {
      type: String,
      default: "primary"
    },
    expandOnHover: {
      type: Boolean,
      default: false
    },
    permanent: {
      type: Boolean,
      default: true
    },
    miniVariant: {
      type: Boolean,
      default: true
    },
    temporary: {
      type: Boolean,
      default: true
    },
    absolute: {
      type: Boolean,
      default: true
    },
    dark: {
      type: Boolean,
      default: true
    },
    noAppBar: {
      type: Boolean,
      default: false
    },
    noAvatar: {
      type: Boolean,
      default: true
    },
    noProfile: {
      type: Boolean,
      default: true
    },
    noDrawer: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: "360"
    },
    src: {
      type: String,
      default: ""
    },
    titleNotifications: {
      type: String,
      default: ""
    },
    notifications: {
      type: Array,
      default: () => {
        return [];
      }
    },
    maxWidthNotification: {
      type: String,
      default: "300"
    },
    noNotification: {
      type: Boolean,
      default: false
    },
    noProfile: {
      type: Boolean,
      default: false
    },
    srcProfile: {
      type: String,
      default: ""
    },
    nameProfile: {
      type: String,
      default: ""
    },
    menuItemsProfile: {
      type: Array,
      default: () => {
        return [];
      }
    },
    labelSearch: {
      type: String,
      default: ""
    },
    noSearch: {
      type: Boolean,
      default: false
    },
    logoMaxHeight: {
      type: String,
      default: "120"
    },
    logoMaxWidth: {
      type: String,
      default: "120"
    },
    autoSelectMenu: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      modelDrawer: false,
      modelMenuSelect: "",
      search: ""
    };
  },

  computed: {
    getFirstNameProfile() {
      let names = this.nameProfile.split(" ");
      return names[0] || "";
    },

    isPermanent() {
      return this.permanent && !this.isMobile;
    },

    isMiniVariant() {
      return this.miniVariant && !this.isMobile;
    },

    isTemporay() {
      return this.temporary && !this.expandOnHover && !this.isPermanent;
    },

    getClassDrawer() {
      return `${this.classDrawer} elevation-3 drawer-tigre`;
    },

    showTitleNotifications() {
      return this.titleNotifications !== '';
    },

    showNotifications() {
      return this.notifications.length > 0;
    },

    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },

    isSmall() {
      return this.$vuetify.breakpoint.width < 450;
    },

    isUltraSmall() {
      return this.$vuetify.breakpoint.width < 350;
    },

    isMedium() {
      return this.$vuetify.breakpoint.width < 1100;
    }

  },
  methods: {
    searchChange() {
      this.$emit('search', this.search);
      this.search = "";
    },

    onDrawer() {
      if (this.expandOnHover) return;
      this.modelDrawer = !this.modelDrawer;
      this.$emit("changeDrawer", this.modelDrawer);
    },

    emitInput(value) {
      this.$emit('input', value);
    },

    onListItemChange($event, valueFather = null) {
      if (this.modelDrawer) this.onDrawer();
      this.$emit("change", $event);
      let valueInput = valueFather || $event;
      this.emitInput(valueInput);
    },

    notificationSelected(notification) {
      this.$emit('notificationSelected', { ...notification
      });
    },

    menuProfileSelected(itemMenuProfile) {
      let emitEventClick = (itemMenuProfile === null || itemMenuProfile === void 0 ? void 0 : itemMenuProfile.emitEventClick) || 'menuProfileSelected';
      this.$emit(emitEventClick, { ...itemMenuProfile
      });
    },

    /**
     * Quando se clica fora do menu, o drawer não está aberto, é do tipo temporary e não foi clicado em icon
     */
    clickOutSide(e) {
      if (!this.temporary || !this.modelDrawer) return;
      let arrClass = e.target.className.split(" ");

      if (arrClass.indexOf("v-icon") === -1) {
        this.onDrawer();
      }
    },

    selectMenu() {
      if (!this.autoSelectMenu) {
        this.modelMenuSelect = this.menuSelect;
        return;
      }

      let newMenuSelect = '';
      this.menuItems.map(menu => {
        if (this.menuSelect.toString().includes(menu.value)) {
          newMenuSelect = menu.value;
        }
      });
      this.modelMenuSelect = newMenuSelect;
    }

  },

  mounted() {
    this.modelDrawer = this.drawer;
    this.selectMenu();
  },

  watch: {
    menuSelect() {
      this.selectMenu();
    },

    drawer() {
      this.modelDrawer = this.drawer;
    }

  }
};

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('v-navigation-drawer', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.clickOutSide,
      expression: "clickOutSide"
    }],
    class: _vm.getClassDrawer,
    attrs: {
      "value": _vm.modelDrawer,
      "dark": _vm.dark,
      "app": !_vm.absolute,
      "expand-on-hover": _vm.expandOnHover,
      "permanent": _vm.isPermanent,
      "mini-variant": !_vm.modelDrawer && _vm.isMiniVariant,
      "mini-variant-width": "80",
      "temporary": _vm.isTemporay,
      "color": "white",
      "absolute": _vm.absolute,
      "width": _vm.width
    }
  }, [_c('v-list', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item-group', {
    attrs: {
      "value": _vm.modelMenuSelect
    }
  }, [_vm._t("list-items", [_vm._l(_vm.menuItems, function (item) {
    return [_c('div', {
      key: item.text
    }, [_vm._t("list-item", [item.target ? _c('v-list-item', {
      class: {
        'class-active': _vm.modelMenuSelect === item.value
      },
      attrs: {
        "link": "",
        "href": item.value,
        "target": item.target,
        "value": item.value
      },
      on: {
        "click": function ($event) {
          return _vm.onListItemChange(item.value);
        }
      }
    }, [_vm._t("list-item-target", [_c('div', {
      staticClass: "content-item-action"
    }, [item.icon ? _c('v-list-item-action', {
      staticClass: "item-menu-action"
    }, [_c('v-icon', {
      attrs: {
        "size": "28"
      }
    }, [_vm._v(_vm._s(item.icon))])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-list-item-content', {
      staticClass: "text--text content-item-text"
    }, [_c('v-list-item-title', [_vm._v("\n                        " + _vm._s(item.text) + "\n                      ")])], 1), _vm._v(" "), item.iconTarget ? _c('v-list-item-icon', {
      staticClass: "list-icon-target align-self-auto"
    }, [_c('v-icon', {
      attrs: {
        "size": "28",
        "small": ""
      }
    }, [_vm._v("\n                        " + _vm._s(item.iconTarget) + "\n                      ")])], 1) : _vm._e()], {
      "item": item
    })], 2) : !item.children ? _c('v-list-item', {
      class: {
        'class-active': _vm.modelMenuSelect === item.value
      },
      attrs: {
        "link": ""
      },
      on: {
        "click": function ($event) {
          return _vm.onListItemChange(item.value);
        }
      }
    }, [_vm._t("list-item-no-children", [_c('div', {
      staticClass: "content-item-action"
    }, [item.icon ? _c('v-list-item-action', {
      staticClass: "item-menu-action"
    }, [_c('v-icon', {
      attrs: {
        "size": "28"
      }
    }, [_vm._v(_vm._s(item.icon))])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-list-item-content', {
      staticClass: "text--text content-item-text"
    }, [_c('v-list-item-title', [_vm._v("\n                        " + _vm._s(item.text) + "\n                      ")])], 1)], {
      "item": item
    })], 2) : _c('v-list-group', {
      staticClass: "list-group-item",
      class: {
        'class-active': _vm.modelMenuSelect === item.value
      },
      attrs: {
        "tag": "v-list-item",
        "light": "",
        "no-action": ""
      },
      on: {
        "input": function ($event) {
          return _vm.emitInput(item.value);
        }
      },
      scopedSlots: _vm._u([{
        key: "prependIcon",
        fn: function () {
          return [_c('div', {
            staticClass: "content-item-action"
          }, [_c('div', {
            staticClass: "item-menu-action"
          }, [_c('v-icon', {
            attrs: {
              "size": "28"
            }
          }, [_vm._v(_vm._s(item.icon))])], 1)])];
        },
        proxy: true
      }, {
        key: "activator",
        fn: function () {
          return [_c('v-list-item-content', {
            staticClass: "text--text content-item-text"
          }, [_c('v-list-item-title', [_vm._v("\n                        " + _vm._s(item.text) + "\n                      ")])], 1)];
        },
        proxy: true
      }, {
        key: "appendIcon",
        fn: function () {
          return [_c('v-icon', {
            attrs: {
              "size": "28"
            },
            domProps: {
              "textContent": _vm._s('$expand')
            }
          })];
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._t("list-item-children", _vm._l(item.children, function (child, i) {
      return _c('v-list-item', {
        key: i,
        attrs: {
          "link": ""
        },
        on: {
          "click": function ($event) {
            return _vm.onListItemChange(child.value, item.value);
          }
        }
      }, [_c('v-list-item-title', {
        staticClass: "text--text"
      }, [_vm._v("\n                        " + _vm._s(child.text) + "\n                      ")]), _vm._v(" "), child.icon ? _c('v-list-item-icon', [_c('v-icon', {
        attrs: {
          "size": "20"
        }
      }, [_vm._v(_vm._s(child.icon))])], 1) : _vm._e()], 1);
    }), {
      "item": item,
      "on": _vm.onListItemChange
    })], 2)], {
      "item": item,
      "on": _vm.onListItemChange
    })], 2)];
  })], {
    "on": _vm.onListItemChange,
    "menuItems": _vm.menuItems
  })], 2)], 1)], 1), _vm._v(" "), !_vm.noAppBar ? _vm._t("app-bar", [_c('v-app-bar', {
    staticClass: "app-bar-tigre",
    class: _vm.classMenu,
    attrs: {
      "color": "primary",
      "height": "70",
      "dark": "",
      "fixed": "",
      "flat": "",
      "app": ""
    }
  }, [!_vm.noDrawer ? _c('v-app-bar-nav-icon', {
    staticClass: "ml-0",
    attrs: {
      "large": ""
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.onDrawer($event);
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-container', {
    class: {
      'ml-10': !_vm.isSmall,
      'containet-center-img': _vm.isSmall
    }
  }, [_vm.titleAppBar === '' ? _c('v-img', {
    attrs: {
      "src": _vm.src,
      "max-height": _vm.logoMaxHeight,
      "max-width": _vm.logoMaxWidth,
      "contain": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm.titleAppBar !== '' ? _c('v-toolbar-title', [_vm._v(_vm._s(_vm.titleAppBar))]) : _vm._e()], 1), _vm._v(" "), !_vm.noSearch && !_vm.isMobile ? _c('v-text-field', {
    staticClass: "input-search",
    class: {
      'input-medium': _vm.isMedium
    },
    attrs: {
      "solo": "",
      "label": _vm.labelSearch,
      "append-icon": "$search"
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.searchChange($event);
      }
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  }) : _vm._e(), _vm._v(" "), !_vm.noNotification && !_vm.isUltraSmall ? _c('v-menu', {
    attrs: {
      "transition": "scale-transition",
      "origin": "top right",
      "left": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var on = ref.on;
        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          }
        }, on), [_vm.showNotifications ? _c('v-badge', {
          attrs: {
            "content": _vm.notifications.length,
            "value": _vm.notifications,
            "color": "secondary",
            "overlap": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "size": "20"
          },
          domProps: {
            "textContent": _vm._s('$notification')
          }
        })], 1) : _c('v-icon', {
          attrs: {
            "size": "20"
          },
          domProps: {
            "textContent": _vm._s('$notification')
          }
        })], 1)];
      }
    }], null, false, 3740371606)
  }, [_vm._v(" "), _vm.showNotifications ? _c('v-list', {
    attrs: {
      "subheader": _vm.showTitleNotifications,
      "max-width": _vm.maxWidthNotification
    }
  }, [_vm._t("notifications", [_vm.showTitleNotifications ? _c('v-subheader', {
    staticClass: "body-1 font-weight-medium black--text"
  }, [_vm._v(_vm._s(_vm.titleNotifications))]) : _vm._e(), _vm._v(" "), _vm.showTitleNotifications ? _c('v-divider') : _vm._e(), _vm._v(" "), _vm._l(_vm.notifications, function (item, i) {
    return _c('v-list-item', {
      key: i,
      on: {
        "click": function ($event) {
          return _vm.notificationSelected(item);
        }
      }
    }, [_vm._t("notifications-items", [_c('v-list-item-avatar', {
      attrs: {
        "color": item.color
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "white"
      },
      domProps: {
        "textContent": _vm._s(item.icon)
      }
    })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
      staticClass: "text--text",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }), _vm._v(" "), _c('v-list-item-subtitle', {
      staticClass: "text--text caption",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })], 1)])], 2);
  })])], 2) : _vm._e()], 1) : _vm._e(), _vm._v(" "), !_vm.noProfile ? _c('v-menu', {
    attrs: {
      "transition": "scale-transition",
      "origin": "top right",
      "offset-y": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var on = ref.on;
        return [_vm._t("profile-activator", [_c('v-btn', _vm._g({
          staticClass: "btn-transparent pr-0 body-1",
          class: {
            'mr-4': !_vm.isSmall
          },
          attrs: {
            "depressed": "",
            "ripple": false
          }
        }, on), [!_vm.isMobile ? [_vm._v("\n                " + _vm._s(_vm.getFirstNameProfile) + "\n              ")] : _vm._e(), _vm._v(" "), !_vm.isMobile ? _c('v-icon', {
          staticClass: "mr-2",
          attrs: {
            "right": "",
            "dark": ""
          },
          domProps: {
            "textContent": _vm._s('$expand')
          }
        }) : _vm._e(), _vm._v(" "), _c('v-avatar', _vm._g({
          attrs: {
            "size": "45"
          }
        }, on), [_c('img', {
          attrs: {
            "src": _vm.srcProfile,
            "alt": _vm.nameProfile
          }
        })])], 2)], {
          "on": on
        })];
      }
    }], null, true)
  }, [_vm._v(" "), !_vm.noProfile ? _c('v-list', {
    attrs: {
      "subheader": "",
      "width": "280"
    }
  }, [_vm._t("profile-items", [_c('v-subheader', {
    staticClass: "pt-8 pb-8"
  }, [_vm._t("profile-header", [_vm._t("profile-img", [_c('v-list-item-avatar', [_c('v-img', {
    attrs: {
      "src": _vm.srcProfile
    }
  })], 1)]), _vm._v(" "), _vm._t("profile-content", [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "body-2 font-weight-medium black--text",
    domProps: {
      "innerHTML": _vm._s(_vm.nameProfile)
    }
  })], 1)])])], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l(_vm.menuItemsProfile, function (item, i) {
    return _c('v-list-item', {
      key: i,
      on: {
        "click": function ($event) {
          return _vm.menuProfileSelected(item);
        }
      }
    }, [_vm._t("menu-profile-items", [_c('v-list-item-content', [_c('v-list-item-title', {
      staticClass: "text--text",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })], 1)])], 2);
  })])], 2) : _vm._e()], 1) : _vm._e()], 1)], {
    "on": _vm.onDrawer
  }) : _vm._e()], 2);
};

var __vue_staticRenderFns__$4 = [];
/* style */

const __vue_inject_styles__$4 = function (inject) {
  if (!inject) return;
  inject("data-v-17d7a32a_0", {
    source: ".v-navigation-drawer--mini-variant.v-navigation-drawer--open .v-list-item>.content-item-text{position:relative!important;height:auto!important;width:auto!important}.drawer-tigre{position:fixed!important;margin-top:70px}.drawer-tigre .content-item-text>.v-list-item__title{margin-left:32px}.drawer-tigre .content-item-action,.drawer-tigre .list-group-item .v-list-item__icon.v-list-group__header__prepend-icon{text-align:center!important;min-width:48px!important;margin-right:0!important}.drawer-tigre .item-menu-action{width:48px;margin-right:0!important;justify-content:center}.drawer-tigre .list-group-item .v-list-group__items .v-list-item__title{margin-left:25px!important}.drawer-tigre .list-group-item .v-list-group__items .v-icon{margin-top:17px!important}.drawer-tigre .list-group-item .v-list-item__icon.v-list-group__header__prepend-icon{margin-top:17px!important;margin-bottom:19px!important}.drawer-tigre .list-icon-target{padding-left:3px!important}.drawer-tigre .class-active .v-list-item,.drawer-tigre .v-list-item.class-active,.drawer-tigre .v-list-item.v-list-item--active{background-color:var(--v-secondary-base)!important;opacity:1!important}.drawer-tigre .v-list-item .v-icon{color:var(--v-secondary-base)!important}.drawer-tigre .class-active>:not(.v-list-group__items) .v-icon,.drawer-tigre .class-active>:not(.v-list-group__items) .v-list-item__title,.drawer-tigre .v-list-item.v-list-item--active>:not(.v-list-group__items) .v-list-item__title,.drawer-tigre>:not(.v-list-group__items) .v-list-item.v-list-item--active .v-icon{color:var(--v-text-active-base)!important}.drawer-tigre .theme--dark.v-list-item--active::before,.drawer-tigre .theme--dark.v-list-item:hover::before{opacity:0!important}.drawer-tigre .v-list-group__items .v-list-item{background-color:#fff!important}.app-bar-tigre .input-search .v-icon,.drawer-tigre .v-list-group__items .v-list-item.v-list-item--active .v-icon{color:var(--v-secondary-base)!important}.drawer-tigre .v-list-item{min-height:60px!important}.drawer-tigre .v-list-item__title{font-size:16px!important}.app-bar-tigre .pointer{cursor:pointer}.app-bar-tigre .btn-transparent,.app-bar-tigre .btn-transparent::before{background-color:transparent!important;text-transform:none!important;font-size:15px!important}.app-bar-tigre .btn-transparent:hover::before{opacity:0!important}.app-bar-tigre .input-search .v-input__control{display:contents!important}.app-bar-tigre .input-search .v-input__slot{margin-bottom:0!important;background-color:#fff!important;min-height:40px!important;width:360px!important}.app-bar-tigre .input-search.input-medium .v-input__slot{width:300px!important}.app-bar-tigre .input-search input,.app-bar-tigre .input-search label{color:var(--v-text-base)!important}.app-bar-tigre .containet-center-img{display:flex!important;justify-content:center!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$4 = undefined;
/* module identifier */

const __vue_module_identifier__$4 = undefined;
/* functional template */

const __vue_is_functional_template__$4 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, createInjector, undefined, undefined);

//
var script$3 = {
  model: {
    prop: "show"
  },
  components: {
    VProgressCircular
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    indeterminate: {
      type: Boolean,
      default: true
    },
    width: {
      type: Number || String,
      default: 7
    },
    size: {
      type: Number || String,
      default: 70
    },
    color: {
      type: String,
      default: "primary"
    },
    classProgress: {
      type: String,
      default: "ma-10"
    }
  }
};

/* script */
const __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "text-center"
  }, [_vm.show ? _c('v-progress-circular', {
    class: _vm.classProgress,
    attrs: {
      "indeterminate": _vm.indeterminate,
      "width": _vm.width,
      "size": _vm.size,
      "color": _vm.color
    }
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__$3 = [];
/* style */

const __vue_inject_styles__$3 = undefined;
/* scoped */

const __vue_scope_id__$3 = undefined;
/* module identifier */

const __vue_module_identifier__$3 = undefined;
/* functional template */

const __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

//
var script$2 = {
  props: {
    fluid: {
      type: Boolean,
      default: true
    },
    classContainer: {
      type: String,
      default: ""
    }
  },
  components: {
    VContainer
  },
  computed: {
    getClass() {
      let classMobile = this.isMobile ? 'mobile' : '';
      return `${this.classContainer} ${classMobile}`;
    },

    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    }

  }
};

/* script */
const __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-container', {
    staticClass: "container-router-view",
    class: _vm.getClass,
    attrs: {
      "fluid": _vm.fluid
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$2 = [];
/* style */

const __vue_inject_styles__$2 = function (inject) {
  if (!inject) return;
  inject("data-v-5159c4e8_0", {
    source: ".container-router-view[data-v-5159c4e8]{padding-left:110px!important;padding-right:30px!important}.container-router-view.mobile[data-v-5159c4e8]{padding-left:12px!important;padding-right:12px!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$2 = "data-v-5159c4e8";
/* module identifier */

const __vue_module_identifier__$2 = undefined;
/* functional template */

const __vue_is_functional_template__$2 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, createInjector, undefined, undefined);

//
var script$1 = {
  components: {
    VDialog,
    VCard,
    VCardText,
    VProgressCircular
  },
  model: {
    prop: 'dialog'
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    zIndex: {
      type: String,
      default: "5"
    }
  }
};

/* script */
const __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-overlay', {
    attrs: {
      "z-index": _vm.zIndex,
      "value": _vm.dialog
    }
  }, [_c('v-container', {
    staticClass: "text-center",
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', [_c('v-progress-circular', {
    staticClass: "ma-10",
    attrs: {
      "indeterminate": "",
      "width": 7,
      "size": 70,
      "color": "primary"
    }
  })], 1)], 1)], 1)], 1);
};

var __vue_staticRenderFns__$1 = [];
/* style */

const __vue_inject_styles__$1 = undefined;
/* scoped */

const __vue_scope_id__$1 = undefined;
/* module identifier */

const __vue_module_identifier__$1 = undefined;
/* functional template */

const __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  props: {
    header: {
      type: String,
      default: ''
    },
    breadcrumb: {
      type: String,
      default: ''
    }
  }
};

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-sheet', {
    attrs: {
      "color": "white",
      "min-height": "90",
      "width": "100%"
    }
  }, [_c('TContainer', {
    attrs: {
      "classContainer": "pt-1"
    }
  }, [_vm._t("breadcrumb", [_c('p', {
    staticClass: "body-2 mt-2 mb-2 text--text"
  }, [_vm._v(_vm._s(_vm.breadcrumb))])]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.header))]), _vm._v(" "), _vm._t("content")], 2)], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = undefined;
/* scoped */

const __vue_scope_id__ = undefined;
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

/* eslint-disable import/prefer-default-export */

var components = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TPagination: __vue_component__$5,
    TMenu: __vue_component__$4,
    TProgressCircular: __vue_component__$3,
    TContainer: __vue_component__$2,
    TLoading: __vue_component__$1,
    THead: __vue_component__
});

const arrPropsColors = ['background', 'input', 'primary', 'secondary', 'text', 'text-active'];
const arrPropsIcons = ['search', 'notification'];

const errorTheme = vuetify => {
  var _vuetify$userPreset, _vuetify$userPreset$t, _vuetify$userPreset$t2, _vuetify$userPreset2, _vuetify$userPreset2$, _vuetify$userPreset2$2;

  let error = false;

  if (vuetify && !(vuetify !== null && vuetify !== void 0 && (_vuetify$userPreset = vuetify.userPreset) !== null && _vuetify$userPreset !== void 0 && (_vuetify$userPreset$t = _vuetify$userPreset.theme) !== null && _vuetify$userPreset$t !== void 0 && (_vuetify$userPreset$t2 = _vuetify$userPreset$t.options) !== null && _vuetify$userPreset$t2 !== void 0 && _vuetify$userPreset$t2.customProperties)) {
    console.error("Necessário atribuir a propriedade customProperties nas configurações do vuetify: options: { customProperties: true }");
    error = true;
  }

  if (vuetify && !(vuetify !== null && vuetify !== void 0 && (_vuetify$userPreset2 = vuetify.userPreset) !== null && _vuetify$userPreset2 !== void 0 && (_vuetify$userPreset2$ = _vuetify$userPreset2.theme) !== null && _vuetify$userPreset2$ !== void 0 && (_vuetify$userPreset2$2 = _vuetify$userPreset2$.themes) !== null && _vuetify$userPreset2$2 !== void 0 && _vuetify$userPreset2$2.light)) {
    console.error("Necessário atribuir as cores ao vuetify: themes: { ligth: {...} }");
    error = true;
  } else {
    arrPropsColors.map(prop => {
      var _vuetify$userPreset$t3;

      if (((_vuetify$userPreset$t3 = vuetify.userPreset.theme.themes.light) === null || _vuetify$userPreset$t3 === void 0 ? void 0 : _vuetify$userPreset$t3[prop]) === undefined) {
        console.error(`Necessário declarar a cor "${prop}" em "themes: { ligth: {...} }"`);
        error = true;
      }
    });
  }

  return error;
};

const errorIcons = vuetify => {
  var _vuetify$userPreset3, _vuetify$userPreset3$;

  let error = false;

  if (vuetify && !(vuetify !== null && vuetify !== void 0 && (_vuetify$userPreset3 = vuetify.userPreset) !== null && _vuetify$userPreset3 !== void 0 && (_vuetify$userPreset3$ = _vuetify$userPreset3.icons) !== null && _vuetify$userPreset3$ !== void 0 && _vuetify$userPreset3$.values)) {
    console.error("Necessário atribuir os icones ao vuetify: icons: { values: {...} }");
    error = true;
  } else {
    arrPropsIcons.map(prop => {
      var _vuetify$userPreset$i;

      if (((_vuetify$userPreset$i = vuetify.userPreset.icons.values) === null || _vuetify$userPreset$i === void 0 ? void 0 : _vuetify$userPreset$i[prop]) === undefined) {
        console.error(`Necessário declarar o icone "${prop}" em "icons: { values: {...} }"`);
        error = true;
      }
    });
  }

  return error;
};

const errorVuetify = vuetify => {
  if (!vuetify) {
    console.error("Necessário atribuir o vuetify ao plugin: Vue.use(PluginTigreLayout, vuetify)");
    return true;
  }

  return errorTheme(vuetify) || errorIcons(vuetify);
};

// Import vue components

const install = function installPluginTigreLayout(Vue, vuetify = null) {
  if (errorVuetify(vuetify)) return;
  Object.entries(components).forEach(([componentName, component]) => {
    Vue.component(componentName, component);
  });
}; // Create module definition for Vue.use()

export default install;
export { __vue_component__$2 as TContainer, __vue_component__ as THead, __vue_component__$1 as TLoading, __vue_component__$4 as TMenu, __vue_component__$5 as TPagination, __vue_component__$3 as TProgressCircular };
